import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["regionIds", "isReady"];
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SelectableNodeEnum } from "utils/Enums";
import React from "react";
import AsyncSelect from "../AsyncSelect/AsyncSelect";
import { jsx as _jsx } from "react/jsx-runtime";
var MarketSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var regionIds = _ref.regionIds,
    isReady = _ref.isReady,
    rest = _objectWithoutProperties(_ref, _excluded);
  var extraParams = {};
  if (regionIds) {
    extraParams.regionIds = regionIds;
  }
  if (isReady != null) {
    extraParams.isReady = isReady;
  }
  var props = _objectSpread({
    placeholder: "Search for a Market",
    nodeType: SelectableNodeEnum.MARKETS.name,
    extraParams: extraParams
  }, rest);
  return /*#__PURE__*/_jsx(AsyncSelect, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});
export default MarketSelect;